import gql from 'graphql-tag'
import { creditClient } from './fragments'

const query = gql`
query CAmaster_getCreditClient($id: ID!) {
	cashAssist {
		getCreditClient(id: $id) {
			id
			...creditClient
		}
	}
}
${creditClient}`

export default query
